import { createApp } from 'vue'
import { createPinia } from 'pinia'
import InstantSearch from 'vue-instantsearch/vue3/es'

import Accordion from './components/Accordion'
import AccordionSlider from './components/AccordionSlider'
import AlgoliaCaseStudiesSearch from './components/algolia/CaseStudiesSearch'
import AlgoliaInsightsSearch from './components/algolia/InsightsSearch'
import AlgoliaGlobalSearch from './components/algolia/GlobalSearch'
import AlgoliaVacanciesSearch from './components/algolia/VacanciesSearch'
import ApplyButton from "./components/ApplyButton";
import CarouselCards from './components/CarouselCards'
import CarouselGallery from './components/CarouselGallery'
import CaseStudySlider from './components/CaseStudySlider'
import CustomSelect from './components/CustomSelect'
import Download from "./components/Download";
import Form from './components/FormFields'
import FormModal from "./components/FormModal";
import GeneralUseCarousel from './components/GeneralUseCarousel'
import InformationTime from "./components/InformationTime"
import LargeText from './components/LargeText'
import LogoCarousel from './components/LogoCarousel'
import NavigationBar from './components/NavigationBar'
import NavigationModal from './components/NavigationModal'
import NavigationToggle from './components/NavigationToggle'
import OfficeSlider from './components/OfficeSlider'
import Observer from './components/Observer'
import ProductFeatures from "./components/ProductFeatures";
import ProductSlider from './components/ProductSlider'
import RichTextWithStickyHeaders from "./components/RichTextWithStickyHeaders"
import SocialIcons from './components/SocialIcons'
import SuccessStats from './components/SuccessStats'
import TestimonialsSlider from './components/TestimonialsSlider'
import VideoEmbed from './components/VideoEmbed'
import VideoModal from './components/VideoModal'
import VacanciesSlider from "./components/VacanciesSlider";
import VmwareStat from "./components/VmwareStat";
import Chart from "./components/chart/Chart";
import HubspotForm from "./components/HubspotForm.vue";

window.reduced_motion = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

const pinia = createPinia()
const app = createApp({})

app.component('accordion', Accordion)
app.component('accordion-slider', AccordionSlider)
app.component('algolia-case-studies-search', AlgoliaCaseStudiesSearch)
app.component('algolia-insights-search', AlgoliaInsightsSearch)
app.component('algolia-global-search', AlgoliaGlobalSearch)
app.component('algolia-vacancies-search', AlgoliaVacanciesSearch)
app.component('apply-button', ApplyButton)
app.component('carousel-cards', CarouselCards)
app.component('carousel-gallery', CarouselGallery)
app.component('case-study-slider', CaseStudySlider)
app.component('chart', Chart)
app.component('custom-select', CustomSelect)
app.component('download', Download)
app.component('form-fields', Form)
app.component('form-modal', FormModal)
app.component('general-use-carousel', GeneralUseCarousel)
app.component('information-time', InformationTime)
app.component('large-text', LargeText)
app.component('logo-carousel', LogoCarousel)
app.component('navigation-bar', NavigationBar)
app.component('navigation-modal', NavigationModal)
app.component('navigation-toggle', NavigationToggle)
app.component('office-slider', OfficeSlider)
app.component('observer', Observer)
app.component('product-slider', ProductSlider)
app.component('product-features', ProductFeatures)
app.component('rich-text-with-sticky-headers', RichTextWithStickyHeaders)
app.component('social-icons', SocialIcons)
app.component('success-stats', SuccessStats)
app.component('testimonials-slider', TestimonialsSlider)
app.component('vacancies-slider', VacanciesSlider)
app.component('video-embed', VideoEmbed)
app.component('video-modal', VideoModal)
app.component('vmware-stat', VmwareStat)
app.component('hubspot-form', HubspotForm)

app.use(pinia)
app.use(InstantSearch)

app.mount('#app')

window.addEventListener('load', () => {
	const globeVideo = document.getElementById('video-globe');

	if (globeVideo && typeof globeVideo !== 'undefined') {
		const width = window.innerWidth;
		const quality = width < 480 ? 'videoLq' : 'videoHq'

		let sourceMp4 = document.createElement('source');
		let sourceWebm = document.createElement('source');

		sourceMp4.type = 'video/mp4; codecs="mp4a.40.2"';
		sourceWebm.type = 'video/webm; codecs="vp9"';
		sourceMp4.src = `${globeVideo.dataset?.[quality]}.mp4`;
		sourceWebm.src = `${globeVideo.dataset?.[quality]}.webm`;

		globeVideo.appendChild(sourceMp4);
		globeVideo.appendChild(sourceWebm);
	}
});
